import { axios } from '@/utils/retailAxios'

// 协议勾选记录
export async function eventTrack (params) {
  try {
    return await axios({
      url: '/api/flight/leave/trace',
      method: 'post',
      data: {
        name: 'event_track',
        params
      }
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
